import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

export default function PageTitle({ text }) {
  return (
    <Typography
      variant="h4"
      textAlign="center"
      sx={{ my: (theme) => theme.spacing(4), fontWeight: "bold" }}
    >
      {text}
    </Typography>
  )
}

PageTitle.propTypes = {
  text: PropTypes.string,
}
